import FocusTrap from './focus-trap.js';

document.addEventListener('DOMContentLoaded', function () {
    const ACTION_EVENTS = ['click', 'keydown'];
    const MOBILE_SPLIT_ID = '-option-variant-mobile-';
    const MOBILE_VARIANT_CLASS = '.variant-picker__option-values-mobile';
    const MOBILE_VARIANT_INPUTS = `${MOBILE_VARIANT_CLASS} input`;

    const productRender = document.querySelector('product-rerender');
    const observeFormId = productRender.getAttribute('observe-form');

    let activeFocusTrap = null;
    let activeFocusTrapId = null;

    const bodyClasslistToggle = (isOpen) => {
        document.body.classList.toggle('no-scroll', isOpen);
        document.body.classList.toggle('open-details', isOpen);
    }

    /**
     * Handles closing mobile variant option fieldset
     */
    const handleCloseMobileVariantFieldset = (fieldset, button) => {
        if (activeFocusTrap && activeFocusTrapId) {
            if (button && fieldset) {
                button.setAttribute('aria-expanded', 'false');
                fieldset.hidden = true;
                bodyClasslistToggle(false);
                activeFocusTrap?.deactivate();
                activeFocusTrap = null;
                activeFocusTrapId = null;
            }
        }
    };

    /**
     * Handles closing mobile variant option fieldset on ESC key press
     */
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && activeFocusTrap) {
            const fieldset = document.getElementById(activeFocusTrapId);
            const button = document.querySelector(`.variant-picker__option-mobile-button[aria-controls="${activeFocusTrapId}"]`);
            handleCloseMobileVariantFieldset(fieldset, button);
        }
    });

    /**
     * Handles click outside mobile variant option fieldset to close it
     */
    document.body.querySelector('main').addEventListener('click', (e) => {
        e.stopPropagation();
        // If the click is inside the active fieldset, do nothing
        const fieldset = document.getElementById(activeFocusTrapId);
        if (fieldset && fieldset.contains(e.target)) {
            return;
        }

        // When click outside the active fieldset
        if (!activeFocusTrap) {
            return;
        }
        const button = document.querySelector(`.variant-picker__option-mobile-button[aria-controls="${activeFocusTrapId}"]`);
        handleCloseMobileVariantFieldset(fieldset, button);
            
        // By clicking outside, focus should return to the button and the selected mobile option should be the same as on desktop
        button.focus();
        const selectedOption = fieldset.querySelector(`${MOBILE_VARIANT_INPUTS}[checked="checked"]`);
        selectedOption?.click();
    });

    const eventsForFieldset = () => {
        const selectedColor = document.querySelector(`${MOBILE_VARIANT_CLASS}[data-color="true"] input[type="radio"]:checked + label`);
        if (selectedColor) {
            const copyColorToMobileSwatch = document.querySelector('.variant-picker__option-mobile-color-swatch');
            copyColorToMobileSwatch.setAttribute('style', selectedColor.getAttribute('style'));
        }
        const confirmMobileVariantButtons = document.querySelectorAll('.variant-picker__option-confirm-button');

        /**
         * Handles closing mobile variant option fieldset when clicking the close button inside the fieldset
         */
        document.querySelectorAll('.variant-picker__option-close-button').forEach(closeButton => {
            ACTION_EVENTS.forEach(eventType => {
                closeButton.addEventListener(eventType, (e) => {
                    if (eventType === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
                        return;
                    }
                    const fieldsetId = closeButton.getAttribute('aria-controls');
                    const fieldset = document.getElementById(fieldsetId);
                    const button = document.querySelector(`.variant-picker__option-mobile-button[aria-controls="${fieldsetId}"]`);
                    e.preventDefault();
                    handleCloseMobileVariantFieldset(fieldset, button);
                    // By clicking outside, focus should return to the button and the selected mobile option should be the same as on desktop
                    button.focus();
                    const selectedOption = fieldset.querySelector(`${MOBILE_VARIANT_INPUTS}[checked="checked"]`);
                    selectedOption?.click();
                });
            });
        });

        /**
         * Handles mobile variant option fieldset toggling and focus trapping
         */
        document.querySelectorAll('.variant-picker__option-mobile-button').forEach(button => {
            ACTION_EVENTS.forEach(eventType => {
                button.addEventListener(eventType, (event) => {
                    if (eventType === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
                        return;
                    }
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    event.preventDefault();
                    const fieldsetId = button.getAttribute('aria-controls');
                    const fieldset = document.getElementById(fieldsetId);

                    if (!fieldset) {
                        return;
                    }

                    const isExpanded = button.getAttribute('aria-expanded') === 'true';
                    button.setAttribute('aria-expanded', !isExpanded);
                    fieldset.hidden = isExpanded;

                    bodyClasslistToggle(!isExpanded);

                    if (isExpanded) {
                        // Deactivate focus trap when closing
                        activeFocusTrap?.deactivate();
                        activeFocusTrap = null;
                        activeFocusTrapId = null;
                        return
                    }
                    // Set focus trap on fieldset when expanded
                    // Deactivate any existing focus trap before activating a new one
                    activeFocusTrap?.deactivate();
                    
                    const focusTrap = new FocusTrap(fieldset);
                    focusTrap.activate({
                        onEscape: () => {
                            button.setAttribute('aria-expanded', 'false');
                            fieldset.hidden = true;
                            bodyClasslistToggle(false);
                            focusTrap.deactivate();
                            activeFocusTrap = null;
                            activeFocusTrapId = null;
                        },
                        initialFocus: true
                    });
                    activeFocusTrap = focusTrap;
                    activeFocusTrapId = fieldsetId;
                });
            });
        });

        /**
         * Handles confirming mobile variant option selection
         */
        ACTION_EVENTS.forEach(eventType => {
            confirmMobileVariantButtons.forEach(confirmButton => {
                confirmButton.addEventListener(eventType, (event) => {
                    if (eventType === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
                        return;
                    }
                    event.preventDefault();
                    const fieldsetId = confirmButton.getAttribute('aria-controls');
                    const fieldset = document.getElementById(fieldsetId);

                    if (!fieldset) {
                        return;
                    }
                    handleCloseMobileVariantFieldset(fieldset, confirmButton);

                    // Sync selected option with desktop variant picker
                    const selectedOption = fieldset.querySelector(`${MOBILE_VARIANT_INPUTS}:checked`);
                    const optionId = selectedOption.id.split(MOBILE_SPLIT_ID).join('-');
                    if (selectedOption) {
                        document.querySelectorAll(`input[id="${optionId}"]`).forEach(input => {
                            input.click();
                        });
                    }
                });
            });
        });
    }

    eventsForFieldset();

    document.forms[observeFormId].addEventListener('product:rerender', (event) => {
        const newContent = event.detail.htmlFragment;
        const madeInValue = newContent.querySelector(`script[data-made-in]`);
        const newContentBarcodeElement = newContent.querySelector('[data-barcode]');
        
        madeInValue && document.querySelectorAll('[data-made-in]').forEach(madeInElement => {
            madeInElement.textContent = madeInValue.textContent.replace(/"/g, '');
        });
            
        newContentBarcodeElement && document.querySelectorAll('[data-barcode]').forEach(barcodeElement => {
            barcodeElement.textContent = newContentBarcodeElement.textContent;
        });
    });

    document.forms[observeFormId].addEventListener('variant:change', (event) => {
        /** 
         * Update mobile variant fieldset events on variant change because the fieldset content will be re-rendered
         */
        eventsForFieldset();
        try {
            initSwymShopify('product')
        } catch (error) {
            console.warn('Swym Shopify integration: ', error);
        }
    });
});